export default [
  {
    path: '/link-de-pagamento',
    component: () => import('@/feature/paymentLink/views/PaymentLinkWrapper.vue'),
    name: 'payment-link-wrapper',
    children: [
      {
        path: '/link-de-pagamento/resumo',
        component: () => import('@/feature/paymentLink/views/PaymentLinkOverview.vue'),
        name: 'payment-link-overview',
      },
      {
        path: '/link-de-pagamento/verificar-credito',
        component: () => import('@/feature/paymentLink/views/PaymentLinkVerifyCredit.vue'),
        name: 'payment-link-verify-credit',
      },
      {
        path: '/link-de-pagamento/verificar-credito/endereco',
        component: () => import('@/feature/paymentLink/views/PaymentLinkVerifyCreditComplement.vue'),
        name: 'payment-link-apply-complement',
      },
      {
        path: '/link-de-pagamento/nao-liberado',
        component: () => import('@/feature/paymentLink/views/PaymentLinkCreditDenied.vue'),
        name: 'payment-link-credit-denied',
      },
      {
        path: '/link-de-pagamento/parcelamento',
        component: () => import('@/feature/paymentLink/views/PaymentLinkSelectOptions.vue'),
        name: 'payment-link-select-option',
      },
      {
        path: '/link-de-pagamento/expirado',
        component: () => import('@/feature/paymentLink/views/PaymentLinkExpired.vue'),
        name: 'payment-link-expired',
      },
    ],
  },
  {
    path: '/link-de-pagamento/error',
    name: 'payment-link-error',
    component: () => import('@/views/Error.vue'),
  },
];
